// 手机话费充值——微信，主流程
const wxMainRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `phone/wx/index${i + 1}`,
  name: `phoneWxIndex${i + 1}`,
  component: () => import(`@/views/life/phone/wx/index${i + 1}.vue`)
}))

// 手机话费充值——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `phone/zfb/index${i + 1}`,
  name: `phoneZfbIndex${i + 1}`,
  component: () => import(`@/views/life/phone/zfb/index${i + 1}.vue`),
}));

export default {
  path: '/life',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 手机话费充值——微信，开始
    ...wxMainRoutes,

    // 手机话费充值——支付宝，主流程
    ...zfbMainRoutes,
  ]
}
